import * as ko from "knockout";
export class address_book_record {
  id: KnockoutObservable<string>;
  cf0: KnockoutObservable<string>; // partner id
  cf1: KnockoutObservable<string>; // customer name
  cf2: KnockoutObservable<string>; // customer address
  cf3: KnockoutObservable<string>; // customer zip
  cf4: KnockoutObservable<string>; // km
  cf5: KnockoutObservable<string>; // timestamp change

  constructor(item?: any) {
    this.id = ko.observable(item?.id ?? "");
    this.cf0 = ko.observable(item?.cf0 ?? "");
    this.cf1 = ko.observable(item?.cf1 ?? "");
    this.cf2 = ko.observable(item?.cf2 ?? "");
    this.cf3 = ko.observable(item?.cf3 ?? "");
    this.cf4 = ko.observable(item?.cf4 ?? "");
    this.cf5 = ko.observable(item?.cf5 ?? "");
  }
}
